import React, { useEffect, useState, useRef } from "react";
import * as XLSX from "xlsx";
import { useReactToPrint } from "react-to-print";
import PrintableTable from "./printTable";
import { orderValues, initialSortValue } from "./constants/constants";
import { getBuyerOutStandingDataRequest, setOrder, sortData } from "./helpers/helpers";
import { useAuctionDetail } from "../../components/common/AunctioneerDeteailProvider";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { fetchBuyerOutsPaymtDetailData } from "../../store/actions";
import generatePDF from "react-to-pdf";

const BuyerOutstandingPaymentReport = ({ reportingId, reportTitle }) => {
  const seasonYear = moment().year();
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = 0; i <= 6; i++) {
    const year = currentYear - i;
    years.push(year);
  }

  const pdfContainerRef = useRef();
  const [isPrintAllowed, setIsPrintAllowed] = useState(false);
  const [isExcelExportAllowed, setIsExcelExportAllowed] = useState(false);
  const [isPdfExportAllowed, setIsPdfExportAllowed] = useState(false);
  const [isSerchRequest, setIsSerchRequest] = useState(false);
  const [season, setSeason] = useState(seasonYear);
  const [responseData, setResponseData] = useState(null);
  const [sortedTableData, setSortedTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = responseData?.recordPerPage || 10;
  const [sortedField, setSortedField] = useState(initialSortValue);
  const [paginationInputValue, setPaginationInputValue] = useState("");
  const handlePrint = useReactToPrint({
    content: () => pdfContainerRef.current,
  });
  const dispatch = useDispatch();
  const { auctionCenterId, auctionTypeMasterId } = useAuctionDetail();

  const getBuyerOutstandingReportData = useSelector(
    (state) => state?.buyerOutstandingPaymentDetailReportReducer?.data?.responseData
  );

  const [DealBookSearch, setDealBookSearch] = useState({
    season: season + "",
    saleNo: null,
    saleDate: null,
    mark: null,
    buyerName: null,
  });

  useEffect(() => {
    getBuyerOutStandingDataRequest({
      auctionCenterId,
      auctionVarient: auctionTypeMasterId,
      setResponseData,
    });
  }, []);

  const orderValues = {
    asc: "asc",
    desc: "desc"
  };
  
  const sortData = (data, sortedField) => {
    const { fieldName, order } = sortedField;
  
    return data.sort((a, b) => {
      if (a[fieldName] < b[fieldName]) return order === orderValues.asc ? -1 : 1;
      if (a[fieldName] > b[fieldName]) return order === orderValues.asc ? 1 : -1;
      return 0;
    });
  };
  
  useEffect(() => {
    if (getBuyerOutstandingReportData) {
      const sortedData = sortData(getBuyerOutstandingReportData, sortedField);
      setSortedTableData(sortedData);
    } else {
      setSortedTableData([])
    }
  }, [getBuyerOutstandingReportData, sortedField]);
  
  const handleSort = (field) => {
    const newOrder = sortedField.fieldName === field && sortedField.order === orderValues.asc
      ? orderValues.desc
      : orderValues.asc;
  
    setSortedField({
      fieldName: field,
      order: newOrder
    });
  };


  if (!responseData) {
    return <div>Loading...</div>;
  }

  const handleExcelExport = () => {
    const table = document.getElementById("table-content");
    const wb = XLSX.utils.table_to_book(table);
    XLSX.writeFile(wb, "BuyerOutstandingPaymentReport.xlsx");
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const itemsToDisplay = sortedTableData.slice(startIndex, endIndex);
  const totalPages = Math.ceil(sortedTableData.length / itemsPerPage);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const columnNames = ["Buyer", "Mark", "No Of Lots", "No Of Packages", "Amount Pending", "Sale Date", "Buyer Prompt Date"]

  const handleViewDealSearch = (e) => {
    const { name, value } = e.target;
    const seasonValue = name === "season" ? String(value) : value;
    setDealBookSearch((prevTaxInvoiceSearch) => ({
      ...prevTaxInvoiceSearch,
      [name]: seasonValue,
    }));
    setSeason(seasonValue);
  }

  const handleSearch = () => {
    let searchData = {
      auctionCenterId: auctionCenterId,
      auctionVarient: auctionTypeMasterId,
      season: DealBookSearch.season,
      saleNo: DealBookSearch.saleNo,
      saleDate: DealBookSearch.saleDate ? moment(DealBookSearch.saleDate).format("YYYY-MM-DD HH:mm:ss.SSSSSSS") : null,
      // saleDate: "2024-07-04 12:05:00.0000000", // Update with a dynamic date if needed
      markId: DealBookSearch.mark ? DealBookSearch.mark : null,
      buyerId: DealBookSearch.buyerName,
    };

    dispatch(fetchBuyerOutsPaymtDetailData(searchData));
  };

  const handleFormReset = () => {
    // if (isErrorMessageOpen) setIsErrorMessageOpen(false);
    setDealBookSearch({
      season: "",
      saleNo: "",
      saleDate: "",
      mark: "",
      buyerName: "",
    });
  };

  return (
    <div>
      <div className="row">
        <div className="col-xl-2">
          <label>Season</label>
          <select
            name='season'
            value={DealBookSearch.season}
            className="form-control select-form"
            onChange={handleViewDealSearch}
          >
            <option value=''>Select Year</option>
            {responseData?.season?.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
        <div className="col-xl-2">
          <div className="FomrGroup">
            <label>Sale No</label>
            <label className="errorLabel"> * </label>
            <select
              name="saleNo"
              onChange={handleViewDealSearch}
              value={DealBookSearch.saleNo}
              className="form-control select-form"
            >
              <option value="">Select Sale No</option>
              {responseData?.saleNo?.map((allSaleNoList, index) => (
                <option key={allSaleNoList} value={allSaleNoList}>
                  {allSaleNoList}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="col-xl-2">
          <div className="FomrGroup">
            <label>Buyer Name</label>
            <select
              name="buyerName"
              value={DealBookSearch.buyerName}
              className="form-control select-form"
              onChange={handleViewDealSearch}
            >
              <option value="">Select Buyer Name</option>
              {responseData?.buyer?.map((getData, index) => (
                <option key={index} value={getData.buyerId}>
                  {getData.Buyer}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="col-xl-2">
          <div className="FomrGroup">
            <label>Sale Date</label>
            <select
              name="saleDate"
              value={DealBookSearch.saleDate}
              className="form-control select-form"
              onChange={handleViewDealSearch}
            >
              <option value="">Select Sale Date</option>
              {responseData?.saleDate?.map((getData, index) => (
                <option value={getData}>
                  {getData}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="col-xl-2">
          <div className="FomrGroup">
            <label>Mark</label>
            <select
              name="mark"
              value={DealBookSearch.mark}
              className="form-control select-form"
              onChange={handleViewDealSearch}
            >
              <option value="">Select Mark</option>
              {responseData?.mark?.map((getData, index) => (
                <option value={getData.markId}>
                  {getData.markname}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="BtnGroup mb-3">
        <button className="SubmitBtn" onClick={handleFormReset}>
          Clear
        </button>
        <button className="SubmitBtn" onClick={() => handleSearch()}>
          Search
        </button>
        {/* {isSearchPopupOpen && (
          <button
            className="SubmitBtn"
            onClick={() => setIsSearchPopupOpen(false)}
          >
            -
          </button>
        )} */}
      </div>

      <div className="TableBox">
        <table className="table" id="table-content">
          <thead>
            <tr>
              {columnNames.map(
                (name, index) => (
                  <th
                    key={index}
                    onClick={() => handleSort(name.toLowerCase().replace(" ", ""))}
                    style={{ cursor: "pointer" }}
                  >
                    {name}{" "}
                    {sortedField.fieldName === name.toLowerCase().replace(" ", "") &&
                      sortedField.order === orderValues.asc ? (
                      <span>▲</span>
                    ) : (
                      <span>▼</span>
                    )}
                  </th>
                )
              )}
            </tr>
          </thead>
          <tbody>
            {itemsToDisplay.length ? (
              itemsToDisplay?.map((item, rowIndex) => (
                <tr key={rowIndex}>
                  <td>{item.buyer}</td>
                  <td>{item.mark}</td>
                  <td>{item.noOfLots}</td>
                  <td>{item.noOfPackages}</td>
                  <td>{item.amountPending}</td>
                  <td>{item.saleDate}</td>
                  <td>{item.buyerPromptDate}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="NoData">
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="pagination">
        <div style={{ marginTop: "18px", marginRight: "12px" }}>
          Page {currentPage} / {totalPages == 0 ? '1': totalPages}
        </div>
        <input
          style={{ width: "50px", marginRight: "12px", marginTop: "18px" }}
          className="form-control"
          type="number"
          value={paginationInputValue}
          onChange={(e) => setPaginationInputValue(e.target.value)}
        />
        <div className="BtnGroup">
          <button
            className="SubmitBtn"
            disabled={
              +paginationInputValue < 1 ||
              !Number.isInteger(+paginationInputValue) ||
              +paginationInputValue === currentPage ||
              +paginationInputValue > totalPages
            }
            onClick={() => {
              handlePageChange(+paginationInputValue);
            }}
          >
            Go
          </button>
          <button
            className="SubmitBtn"
            onClick={() => handlePageChange(1)}
            disabled={currentPage === 1}
          >
            First
          </button>
          <button
            className="SubmitBtn"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <button
            className="SubmitBtn"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
          <button
            className="SubmitBtn"
            onClick={() => handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
          >
            Last
          </button>
        </div>
      </div>

      <div style={{ overflow: "hidden", width: "100%", height: "0" }}>
        <div id="table-content" ref={pdfContainerRef}>
          <PrintableTable
            columnNames={columnNames}
         
            data={
              sortedTableData
            }
            isBuyerPaymentDetailReport
            title={'Buyer Outstanding Payment Detail Report'}
          />
        </div>
      </div>

      <div className="BtnGroup">
        {getBuyerOutstandingReportData?.length > 0 && (
          <button className="SubmitBtn" onClick={handlePrint}>
            Print
          </button>
        )}
        {getBuyerOutstandingReportData?.length > 0 && (
          <button onClick={handleExcelExport} className="SubmitBtn">
            Export to Excel
          </button>
        )}
        {getBuyerOutstandingReportData?.length > 0 && (
          <button
            className="SubmitBtn"
            onClick={() =>
              generatePDF(pdfContainerRef, { filename: "exportPDF.pdf" })
            }
          >
            Export to PDF
          </button>
        )}
      </div>
    </div>
  );
};

export default BuyerOutstandingPaymentReport;
